export const services = {
  'dental-implants': {
    slug: 'dental-implants',
    questionH1: 'Are Dental Implants Right for You?',
    metaTitle: 'Dental Implants Acton — Permanent Tooth Replacement | Dr. Kartik Patel',
    metaDescription: 'Expert dental implants in Acton. Permanent solution for missing teeth. 15+ years experience. CBCT imaging, same-day surgery. 0% finance. Book consultation.',
    keywords: 'dental implants Acton, tooth replacement West London, implant dentist, permanent dentures alternative, single tooth implant',
    
    tldr: "Dental implants are the gold-standard solution for permanent tooth replacement. Unlike dentures or bridges, implants fuse with your jawbone to provide a stable foundation that looks, feels, and functions like a natural tooth. At Restore.Dental, Dr. Kartik Patel uses advanced CBCT imaging and digital planning to place implants with precision, minimizing healing time and maximizing long-term success. Whether you're replacing a single tooth, multiple teeth, or need full-arch restoration, implants restore confidence alongside function. With proper care, dental implants can last 25+ years — making them a genuine long-term investment in your oral health and quality of life. We offer 0% finance to make treatment accessible.",
    
    whoItsFor: [
      'Adults with one or more missing teeth who want permanent replacement',
      'Patients tired of dentures slipping, clicking, or limiting food choices',
      'Anyone wanting to prevent bone loss after tooth extraction',
      'People who\'ve been told "you need bone grafting" — we assess honestly',
      'Patients seeking a solution that lasts decades, not years'
    ],
    
    treatmentApproach: {
      title: 'Our Implant Treatment Process',
      steps: [
        {
          number: 1,
          title: 'Comprehensive Assessment',
          description: 'CBCT 3D scan to assess bone quality, nerve position, and sinus anatomy. Honest discussion: are you a good implant candidate, or are there better options?'
        },
        {
          number: 2,
          title: 'Digital Planning',
          description: 'Virtual implant placement to determine optimal position, angle, and depth. We show you the plan before treatment begins.'
        },
        {
          number: 3,
          title: 'Surgical Placement',
          description: 'Implant placed under local anesthetic (sedation available for anxious patients). Most patients report less discomfort than a tooth extraction.'
        },
        {
          number: 4,
          title: 'Healing Period',
          description: '3-6 months for implant to fuse with bone (osseointegration). Temporary tooth provided if needed.'
        },
        {
          number: 5,
          title: 'Final Restoration',
          description: 'Custom crown, bridge, or denture attached to implant. Color-matched to your natural teeth for seamless aesthetics.'
        }
      ]
    },
    
    faqs: [
      {
        question: 'How long do dental implants last?',
        answer: 'With proper care (brushing, flossing, regular check-ups), dental implants can last 25+ years or even a lifetime. The crown attached to the implant may need replacement after 10-15 years due to normal wear, but the implant itself typically remains stable indefinitely.'
      },
      {
        question: 'Is implant surgery painful?',
        answer: 'Most patients report implant surgery is less painful than expected. The procedure is done under local anesthetic, and many patients describe it as similar to or easier than a tooth extraction. Post-operative discomfort is typically managed with over-the-counter pain relief. We offer sedation dentistry for anxious patients.'
      },
      {
        question: 'How much do dental implants cost?',
        answer: 'A single implant with crown typically costs £2,500-£3,500 at Restore.Dental. Full-arch implant solutions (All-on-4) range from £12,000-£18,000. We offer 0% interest-free finance to spread the cost over 12-24 months. Exact fees depend on your specific needs — we provide a detailed written quote after assessment.'
      },
      {
        question: 'Am I too old for dental implants?',
        answer: 'Age alone is rarely a barrier to implant treatment. We successfully place implants in patients from their 20s to their 90s. What matters is bone quality, overall health, and healing capacity. Conditions like uncontrolled diabetes or heavy smoking may affect success rates, but most older adults are excellent implant candidates.'
      },
      {
        question: 'What if I don\'t have enough bone?',
        answer: 'Bone grafting can often build sufficient bone for implant placement. However, Dr. Patel assesses each case honestly — sometimes alternative treatments (bridges, dentures, or smaller-diameter implants) are more appropriate. We never recommend grafting unless it\'s genuinely necessary and likely to succeed.'
      },
      {
        question: 'Can I have implants if I have gum disease?',
        answer: 'Active gum disease must be treated before implant placement to ensure long-term success. Dr. Patel will address periodontal issues first, then proceed with implants once your gums are healthy. Skipping this step dramatically increases the risk of implant failure.'
      },
      {
        question: 'How soon after tooth extraction can I get an implant?',
        answer: 'In some cases, we can place an implant immediately after extraction (same-day). More commonly, we wait 3-6 months for the extraction site to heal and bone to stabilize. Dr. Patel assesses your specific situation and recommends the optimal timing for your case.'
      }
    ],
    
    aftercare: {
      title: 'Caring for Your Dental Implants',
      instructions: [
        'Brush twice daily with a soft-bristle toothbrush',
        'Floss daily using implant-specific floss or interdental brushes',
        'Avoid smoking — it increases implant failure risk significantly',
        'Attend regular hygiene appointments (every 6 months minimum)',
        'Wear a nightguard if you grind your teeth',
        'Report any looseness, pain, or bleeding around the implant immediately'
      ],
      note: 'Implants don\'t get cavities, but they can fail if surrounding gum and bone become infected (peri-implantitis). Excellent oral hygiene is critical for long-term success.'
    },
    
    relatedServices: ['all-on-4-implants', 'full-mouth-reconstruction', 'porcelain-veneers']
  },

  'porcelain-veneers': {
    slug: 'porcelain-veneers',
    questionH1: 'Could Porcelain Veneers Transform Your Smile?',
    metaTitle: 'Porcelain Veneers Acton — Smile Makeover | Restore.Dental',
    metaDescription: 'Premium porcelain veneers in Acton. Natural-looking smile transformations. Digital smile design, minimal prep. Dr. Kartik Patel. 0% finance. Book consultation.',
    keywords: 'porcelain veneers Acton, smile makeover West London, ceramic veneers, cosmetic dentist, teeth veneers cost',
    
    tldr: "Porcelain veneers are ultra-thin ceramic shells bonded to the front of your teeth to correct shape, color, alignment, or size issues. They're the gold standard for dramatic smile transformations — addressing everything from severe staining to chipped edges to gaps between teeth. At Restore.Dental, Dr. Patel uses digital smile design so you see your new smile before treatment begins. Unlike older veneer techniques that required aggressive tooth reduction, modern minimal-prep veneers preserve maximum natural tooth structure. With proper care, porcelain veneers last 10-15 years and resist staining far better than natural teeth. They're an investment in confidence — permanently addressing aesthetic concerns that bonding or whitening can't fix.",
    
    whoItsFor: [
      'Patients with severe staining that whitening can\'t address (tetracycline, fluorosis)',
      'Anyone wanting to correct chip, cracks, or worn edges',
      'People with gaps between teeth who want instant closure',
      'Patients seeking a dramatic, permanent smile makeover',
      'Anyone unhappy with tooth shape, size, or proportions'
    ],
    
    treatmentApproach: {
      title: 'Our Veneer Process',
      steps: [
        {
          number: 1,
          title: 'Digital Smile Design',
          description: 'Photographs, digital mock-up, and sometimes a wax try-in so you see your new smile before we touch your teeth. No surprises.'
        },
        {
          number: 2,
          title: 'Minimal Tooth Preparation',
          description: 'Thin layer of enamel removed (typically 0.5mm) to create space for veneer. Modern techniques preserve maximum natural tooth structure.'
        },
        {
          number: 3,
          title: 'Temporary Veneers',
          description: 'Provisional veneers placed while the ceramics lab crafts your final restorations (2-3 weeks). You leave with a beautiful smile on day one.'
        },
        {
          number: 4,
          title: 'Bonding Appointment',
          description: 'Final porcelain veneers bonded with high-strength adhesive. Color, fit, and bite checked meticulously. No cement lines visible.'
        },
        {
          number: 5,
          title: 'Follow-Up',
          description: 'Review appointment 2 weeks later to ensure comfort and aesthetics. Minor adjustments if needed.'
        }
      ]
    },
    
    faqs: [
      {
        question: 'How long do porcelain veneers last?',
        answer: 'Porcelain veneers typically last 10-15 years with proper care. Some patients get 20+ years from their veneers. Longevity depends on oral hygiene, grinding habits (nightguard recommended), and avoiding using teeth as tools (opening packages, biting nails).'
      },
      {
        question: 'Are veneers painful to get?',
        answer: 'The preparation appointment requires local anesthetic, so the procedure itself is painless. Some patients experience tooth sensitivity for a few days after preparation while wearing temporary veneers. This resolves once final veneers are bonded.'
      },
      {
        question: 'Will veneers look fake or too white?',
        answer: 'Not if done properly. Dr. Patel uses digital smile design and works with a master ceramist to match veneers to your facial proportions and desired brightness. We can create anything from "natural white" to "Hollywood bright" — your choice. Well-designed veneers look like naturally beautiful teeth, not artificial chiclets.'
      },
      {
        question: 'Can I whiten my teeth instead of getting veneers?',
        answer: 'Possibly. Dr. Patel always considers conservative options first. If your teeth are naturally shaped and aligned well, whitening plus bonding may achieve your goals for far less cost. Veneers are recommended when staining is too severe for whitening, or when you also want to change shape/size/alignment.'
      },
      {
        question: 'How much do porcelain veneers cost?',
        answer: 'At Restore.Dental, porcelain veneers typically cost £800-£1,200 per tooth. A full smile makeover (8-10 veneers) ranges from £7,000-£12,000. We offer 0% interest-free finance. Composite veneers are a more affordable alternative at £400-£600 per tooth, though they don\'t last as long.'
      },
      {
        question: 'What\'s the difference between porcelain and composite veneers?',
        answer: 'Porcelain veneers are lab-crafted ceramic shells — stronger, more stain-resistant, and more lifelike than composite veneers (which are applied directly to teeth by the dentist). Porcelain lasts 10-15 years; composite lasts 5-7 years. Porcelain costs more but provides superior aesthetics and durability.'
      },
      {
        question: 'Is tooth preparation reversible?',
        answer: 'No. Once enamel is removed to prepare for veneers, you\'ll always need some form of restoration on those teeth. This is why Dr. Patel uses minimal-prep techniques to preserve maximum natural structure, and why we ensure you\'re certain before proceeding.'
      }
    ],
    
    aftercare: {
      title: 'Maintaining Your Porcelain Veneers',
      instructions: [
        'Brush twice daily with non-abrasive toothpaste',
        'Floss daily — veneers can still get gum disease at the margins',
        'Wear a nightguard if you grind your teeth (essential for longevity)',
        'Avoid biting hard objects (ice, nuts, pen caps)',
        'Don\'t use teeth as tools to open packages or bottles',
        'Attend regular dental check-ups every 6 months'
      ],
      note: 'Porcelain veneers resist staining far better than natural teeth, but they can still chip or debond if abused. Treat them with respect, and they\'ll serve you for decades.'
    },
    
    relatedServices: ['composite-veneers', 'teeth-whitening', 'digital-smile-design']
  },

  'composite-veneers': {
    slug: 'composite-veneers',
    questionH1: 'Are Composite Veneers a Good Alternative to Porcelain?',
    metaTitle: 'Composite Veneers Acton — Same-Day Smile Makeover | Restore.Dental',
    metaDescription: 'Affordable composite veneers in Acton. Same-day smile transformation. Minimal prep, reversible. Dr. Kartik Patel. From £400/tooth. Book consultation.',
    keywords: 'composite veneers Acton, composite bonding, same-day veneers, affordable smile makeover, direct veneers',
    
    tldr: "Composite veneers are tooth-colored resin applied directly to your teeth to improve shape, color, or alignment — completed in a single appointment. Unlike porcelain veneers which require lab fabrication, composite veneers are crafted by the dentist chair-side, making them faster and more affordable. They're ideal for younger patients, those wanting a trial before committing to porcelain, or anyone on a tighter budget. While composite doesn't last as long as porcelain (5-7 years vs. 10-15 years) and stains more easily, it requires minimal tooth preparation and is often reversible. At Restore.Dental, Dr. Patel uses advanced layering techniques to create natural-looking results that rival porcelain aesthetics — at half the cost.",
    
    whoItsFor: [
      'Patients wanting immediate results in one appointment',
      'Anyone seeking a more affordable smile makeover option',
      'Younger patients who may upgrade to porcelain later',
      'People wanting to "test drive" a new smile before committing',
      'Patients with minor chips, gaps, or staining issues'
    ],
    
    treatmentApproach: {
      title: 'Composite Veneer Process',
      steps: [
        {
          number: 1,
          title: 'Color Matching & Design',
          description: 'Shade selection and smile design discussion. Photos taken for reference.'
        },
        {
          number: 2,
          title: 'Minimal Preparation',
          description: 'Often no tooth preparation needed — composite is added to existing tooth surface. If needed, only minimal enamel roughening.'
        },
        {
          number: 3,
          title: 'Layering & Sculpting',
          description: 'Composite resin applied in layers, sculpted to desired shape. Each layer is light-cured to harden.'
        },
        {
          number: 4,
          title: 'Polishing',
          description: 'Final contouring and high-gloss polish to mimic natural tooth sheen.'
        },
        {
          number: 5,
          title: 'Bite Adjustment',
          description: 'Ensuring veneers don\'t interfere with bite or cause jaw discomfort.'
        }
      ]
    },
    
    faqs: [
      {
        question: 'How long do composite veneers last?',
        answer: 'Composite veneers typically last 5-7 years before needing replacement or significant touch-ups. Lifespan depends on oral hygiene, diet (coffee, red wine, smoking all accelerate staining), and grinding habits. They don\'t last as long as porcelain, but they\'re much more affordable and easily repairable.'
      },
      {
        question: 'Do composite veneers stain?',
        answer: 'Yes, composite is more porous than porcelain and will gradually pick up stains from coffee, tea, red wine, curry, and smoking. Professional polishing at dental check-ups helps maintain appearance, but eventually they\'ll need replacement or refresh. Porcelain veneers resist staining far better.'
      },
      {
        question: 'Can composite veneers be done in one day?',
        answer: 'Yes. Unlike porcelain veneers which require lab fabrication (2-3 weeks), composite veneers are completed chair-side in a single 2-3 hour appointment per arch. You leave with your new smile the same day.'
      },
      {
        question: 'Are composite veneers reversible?',
        answer: 'Often yes. If minimal or no tooth preparation was done, composite can be removed to return teeth to their original state. This makes composite a good "trial run" before committing to irreversible porcelain veneers.'
      },
      {
        question: 'How much do composite veneers cost?',
        answer: 'At Restore.Dental, composite veneers cost £400-£600 per tooth — roughly half the price of porcelain. A full smile makeover (8-10 teeth) typically ranges from £3,500-£6,000. We offer 0% finance to spread the cost.'
      },
      {
        question: 'Should I get composite or porcelain veneers?',
        answer: 'It depends on your budget, timeline, and expectations. Choose composite if you want: same-day results, lower cost, reversibility, or a trial before porcelain. Choose porcelain if you want: maximum durability, best stain resistance, longest lifespan, and most lifelike aesthetics. Dr. Patel discusses both options honestly at consultation.'
      },
      {
        question: 'Can composite veneers be repaired if damaged?',
        answer: 'Yes, one advantage of composite is easy repairability. If a veneer chips or stains, it can often be patched or polished during a routine appointment, rather than requiring complete replacement.'
      }
    ],
    
    aftercare: {
      title: 'Caring for Composite Veneers',
      instructions: [
        'Brush twice daily with non-abrasive toothpaste',
        'Avoid staining foods/drinks for first 48 hours after placement',
        'Limit coffee, tea, red wine, and smoking to slow staining',
        'Wear a nightguard if you grind your teeth',
        'Don\'t bite hard objects or use teeth as tools',
        'Attend regular polish appointments every 6 months to maintain shine'
      ],
      note: 'Composite veneers require more maintenance than porcelain. Professional polishing at check-ups and touch-ups every few years help maintain appearance.'
    },
    
    relatedServices: ['porcelain-veneers', 'teeth-whitening', 'digital-smile-design']
  },

  'all-on-4-implants': {
    slug: 'all-on-4-implants',
    questionH1: 'Could All-on-4 Replace Your Dentures Permanently?',
    metaTitle: 'All-on-4 Implants Acton — Fixed Dentures Alternative | Restore.Dental',
    metaDescription: 'All-on-4 full-arch implants in Acton. Permanent denture replacement. Same-day teeth possible. Dr. Kartik Patel. From £12,000. 0% finance. Book consultation.',
    keywords: 'All-on-4 implants Acton, full arch implants, fixed dentures, implant supported dentures, teeth in a day',
    
    tldr: "All-on-4 is a full-arch implant solution that replaces an entire upper or lower set of teeth with just four strategically placed implants supporting a fixed prosthesis. It's designed for patients who've lost most or all their teeth, or who have failing teeth that need extraction. Unlike traditional dentures that slip, click, and limit food choices, All-on-4 provides permanent, stable teeth that function like natural ones. The technique uses angled posterior implants to avoid sinus and nerve structures, often eliminating the need for bone grafting. At Restore.Dental, Dr. Patel uses CBCT planning to determine if you're an All-on-4 candidate, and in many cases can provide temporary teeth the same day as implant surgery — so you never go without teeth.",
    
    whoItsFor: [
      'Patients with most or all teeth missing in one or both arches',
      'Anyone tired of dentures slipping, sore spots, or adhesive gels',
      'People with failing teeth that need extraction and full-arch replacement',
      'Patients who\'ve been told "you don\'t have enough bone" for traditional implants',
      'Anyone wanting permanent teeth that function like natural ones'
    ],
    
    treatmentApproach: {
      title: 'All-on-4 Treatment Process',
      steps: [
        {
          number: 1,
          title: 'Comprehensive Planning',
          description: 'CBCT scan, digital planning to map implant positions avoiding vital structures. Assessment of bone quality and quantity.'
        },
        {
          number: 2,
          title: 'Surgical Day',
          description: 'Four implants placed per arch under local anesthetic or sedation. Failing teeth extracted same day if needed.'
        },
        {
          number: 3,
          title: 'Immediate Temporaries',
          description: 'In many cases, a provisional fixed bridge is attached the same day — you leave with teeth, not a gap.'
        },
        {
          number: 4,
          title: 'Healing Period',
          description: '3-6 months for implants to fuse with bone. Provisional bridge worn throughout — you\'re never without teeth.'
        },
        {
          number: 5,
          title: 'Final Prosthesis',
          description: 'Custom-crafted final bridge made from durable materials (acrylic, zirconia, or porcelain-fused-to-metal). Aesthetics and function perfected.'
        }
      ]
    },
    
    faqs: [
      {
        question: 'How much do All-on-4 implants cost?',
        answer: 'At Restore.Dental, All-on-4 for a single arch typically costs £12,000-£18,000, depending on materials chosen for the final prosthesis. Both arches range from £24,000-£35,000. We offer 0% interest-free finance over 24-36 months to make treatment accessible. While expensive, All-on-4 lasts decades and dramatically improves quality of life compared to dentures.'
      },
      {
        question: 'How long do All-on-4 implants last?',
        answer: 'The implants themselves can last 20+ years or a lifetime with proper care. The prosthetic bridge attached to the implants typically needs replacement every 10-15 years due to wear. This is far superior to traditional dentures, which need relining every few years and full replacement every 5-7 years.'
      },
      {
        question: 'Is All-on-4 surgery painful?',
        answer: 'The procedure is done under local anesthetic, often with sedation for anxious patients. Most patients report less discomfort than expected — similar to multiple extractions. Post-operative swelling and soreness are managed with medication. Having immediate temporary teeth helps psychologically.'
      },
      {
        question: 'Can I eat normally with All-on-4?',
        answer: 'Yes, once healed. With the provisional bridge, you\'ll need a soft diet for 6-8 weeks. Once the final prosthesis is attached, you can eat virtually anything — steak, apples, corn on the cob — things impossible with traditional dentures. This restored function is life-changing for most patients.'
      },
      {
        question: 'What if I don\'t have enough bone for All-on-4?',
        answer: 'All-on-4 uses angled implants and strategic placement to maximize existing bone, often avoiding the need for grafting. However, severe bone loss may require grafting or a different approach. Dr. Patel assesses your specific anatomy with CBCT and discusses realistic options.'
      },
      {
        question: 'How do I clean All-on-4 teeth?',
        answer: 'The bridge is fixed (non-removable), so cleaning requires water flossers, specialized brushes, and threader floss to clean under the prosthesis. Professional hygiene appointments every 3-6 months are essential. Dr. Patel provides detailed training on home care techniques.'
      },
      {
        question: 'What\'s the difference between All-on-4 and traditional implant dentures?',
        answer: 'All-on-4 uses just four implants per arch with a fixed (non-removable) bridge. Traditional implant dentures may use 6-8 implants per arch or have a removable prosthesis that clicks onto implants. All-on-4 is faster, less expensive, and often avoids bone grafting, but may not be suitable for everyone.'
      }
    ],
    
    aftercare: {
      title: 'Maintaining All-on-4 Implants',
      instructions: [
        'Clean under the prosthesis daily with water flosser and specialized brushes',
        'Attend professional hygiene appointments every 3-6 months',
        'Avoid smoking — it dramatically increases implant failure risk',
        'Wear a nightguard if you grind your teeth',
        'Report any looseness, pain, or bleeding immediately',
        'Have prosthesis checked annually for wear or loose screws'
      ],
      note: 'All-on-4 requires diligent home care and professional maintenance. Neglecting hygiene can lead to peri-implantitis (infection around implants), potentially causing implant failure.'
    },
    
    relatedServices: ['dental-implants', 'full-mouth-reconstruction', 'emergency-dentist']
  },

  'full-mouth-reconstruction': {
    slug: 'full-mouth-reconstruction',
    questionH1: 'Is Full-Mouth Reconstruction the Answer to Years of Dental Neglect?',
    metaTitle: 'Full-Mouth Reconstruction Acton — Complex Restorative Dentistry | Restore.Dental',
    metaDescription: 'Full-mouth reconstruction in Acton. Fix failing teeth, restore bite, eliminate pain. Implants, crowns, bridges. Dr. Kartik Patel. 0% finance. Consultation.',
    keywords: 'full mouth reconstruction Acton, full mouth rehabilitation, complex restorative dentistry, failing teeth treatment, bite reconstruction',
    
    tldr: "Full-mouth reconstruction addresses comprehensive dental failure — multiple missing teeth, severe wear, failing crowns/bridges, bite collapse, or chronic pain. It's not a single procedure but a coordinated treatment plan combining implants, crowns, bridges, veneers, and sometimes orthodontics to restore function, aesthetics, and oral health. At Restore.Dental, Dr. Patel uses digital planning and CBCT imaging to create a roadmap that phases treatment logically — addressing pain and infection first, stabilizing bite and structure second, perfecting aesthetics last. Full-mouth cases typically take 12-18 months and cost £15,000-£40,000 depending on complexity. We offer 0% finance and phase treatment to respect both clinical healing and family budgets. The result: a functional, pain-free smile that lasts decades.",
    
    whoItsFor: [
      'Patients with multiple failing teeth, crowns, or fillings',
      'Anyone with severe tooth wear from grinding (bruxism) or acid erosion',
      'People with bite collapse causing jaw pain, headaches, or TMJ issues',
      'Patients who\'ve deferred dental care for years and now face comprehensive needs',
      'Anyone told "you need extensive work" but unsure where to start'
    ],
    
    treatmentApproach: {
      title: 'Full-Mouth Reconstruction Process',
      steps: [
        {
          number: 1,
          title: 'Comprehensive Diagnostic Phase',
          description: 'CBCT scan, photographs, bite analysis, TMJ assessment. Identify root causes, not just symptoms.'
        },
        {
          number: 2,
          title: 'Master Treatment Plan',
          description: 'Detailed roadmap: what needs extraction, what can be saved, implant vs. bridge decisions, timeline, phasing, costs.'
        },
        {
          number: 3,
          title: 'Foundation Phase',
          description: 'Address infection, pain, and structural issues. Extractions, implant placement, gum disease treatment. Get you out of crisis.'
        },
        {
          number: 4,
          title: 'Rehabilitation Phase',
          description: 'Restore teeth with crowns, bridges, or implant restorations. Re-establish proper bite and jaw alignment.'
        },
        {
          number: 5,
          title: 'Aesthetic Refinement',
          description: 'Fine-tune smile aesthetics with veneers, bonding, or whitening once function is restored.'
        }
      ]
    },
    
    faqs: [
      {
        question: 'How long does full-mouth reconstruction take?',
        answer: 'Most full-mouth cases take 12-18 months from start to finish, though this varies widely depending on complexity. Treatment is phased to allow healing between stages. Dr. Patel provides a realistic timeline at your consultation — we never rush treatment just to finish faster.'
      },
      {
        question: 'How much does full-mouth reconstruction cost?',
        answer: 'Costs range from £15,000 to £40,000+ depending on how many teeth need treatment and which procedures are required. A typical case involving 10-12 crowns, 2-3 implants, and some veneers might cost £20,000-£25,000. We offer 0% finance over 24-36 months and can phase treatment to spread costs.'
      },
      {
        question: 'Will I have teeth during treatment?',
        answer: 'Yes. Dr. Patel ensures you never go without teeth. Temporary crowns, bridges, or dentures are provided between appointments so you can eat, speak, and smile normally throughout the process.'
      },
      {
        question: 'Can\'t I just get dentures instead?',
        answer: 'You could, but dentures don\'t address underlying bite, bone loss, or remaining teeth problems. Full-mouth reconstruction aims to preserve and restore what\'s salvageable, using dentures only as a last resort. The result is more functional and longer-lasting than dentures.'
      },
      {
        question: 'Is full-mouth reconstruction painful?',
        answer: 'Each individual procedure (crown prep, implant placement) is done under local anesthetic and is painless during treatment. Post-operative discomfort is managed with medication. The phased approach means you\'re never overwhelmed by pain from extensive work done all at once.'
      },
      {
        question: 'What if I can\'t afford it all at once?',
        answer: 'We phase treatment strategically: addressing emergencies and pain first, then structural issues, then aesthetics. This spreads costs over time while ensuring you\'re never in crisis. 0% finance makes monthly payments manageable for most families.'
      },
      {
        question: 'How do I know if I need full-mouth reconstruction?',
        answer: 'If you have multiple failing teeth, chronic pain, difficulty eating, or have been told you need "extensive work" by other dentists, you may benefit from comprehensive planning. Dr. Patel provides an honest assessment at consultation — sometimes simpler, less expensive approaches can achieve your goals.'
      }
    ],
    
    aftercare: {
      title: 'Maintaining Your Reconstructed Smile',
      instructions: [
        'Brush twice daily with electric toothbrush',
        'Floss daily around all restorations',
        'Wear a nightguard religiously if you grind your teeth (essential)',
        'Attend hygiene appointments every 3-4 months (not 6)',
        'Avoid hard/sticky foods that stress restorations',
        'Report any looseness, pain, or sensitivity immediately'
      ],
      note: 'Full-mouth reconstruction represents a significant investment. Protect it with excellent home care and professional maintenance. Most restorations last 10-20 years with proper care.'
    },
    
    relatedServices: ['dental-implants', 'all-on-4-implants', 'tmj-dentistry', 'porcelain-veneers']
  },

  // ============================================================================
  // ADDITIONAL SERVICES (5/10)
  // ============================================================================

  'invisalign': {
    slug: 'invisalign',
    questionH1: 'Is Invisalign Faster Than Traditional Braces?',
    metaTitle: 'Invisalign Acton — Clear Aligners | 150+ Cases | Dr. Kartik Patel',
    metaDescription: 'Invisalign clear aligners in Acton. Discreet teeth straightening. 150+ cases completed. Experienced provider Dr. Kartik Patel. 0% finance. Free consultation.',
    keywords: 'Invisalign Acton, clear aligners West London, invisible braces, adult orthodontics, teeth straightening',
    
    tldr: "Invisalign uses clear, removable aligners to straighten teeth without metal braces. Each aligner moves teeth incrementally; you swap to a new set every 1-2 weeks. Treatment takes 6-18 months for most cases — often faster than traditional braces. At Restore.Dental, Dr. Kartik Patel is an experienced Invisalign provider with 150+ completed cases, meaning he's seen and solved virtually every orthodontic challenge. Invisalign is nearly invisible, more comfortable than braces, and removable for eating and cleaning. It's ideal for adults and teenagers who want discreet treatment. Digital planning shows your final smile before you commit. With proper wear (22 hours/day), Invisalign delivers predictable, beautiful results — and you never have to avoid foods or struggle with wire adjustments.",
    
    whoItsFor: [
      'Adults who missed orthodontics as children and now want straight teeth',
      'Professionals needing discreet treatment that doesn\'t affect appearance',
      'Teenagers wanting invisible braces instead of metal',
      'Anyone with crowding, spacing, crossbite, or mild-to-moderate overbite',
      'Patients who\'ve had braces but teeth have shifted (relapse cases)'
    ],
    
    treatmentApproach: {
      title: 'Invisalign Treatment Process',
      steps: [
        {
          number: 1,
          title: 'Digital Scan & Planning',
          description: '3D scan of teeth, digital treatment simulation showing tooth movement week-by-week. You see your final smile before starting.'
        },
        {
          number: 2,
          title: 'Custom Aligner Fabrication',
          description: 'Your aligners are manufactured specifically for your case. Delivered in sets (typically 20-40 aligners per arch).'
        },
        {
          number: 3,
          title: 'Aligner Delivery & Training',
          description: 'Pick up first few sets of aligners, learn how to wear/remove them, understand dos and don\'ts.'
        },
        {
          number: 4,
          title: 'Progress Check-Ins',
          description: 'Review appointments every 6-8 weeks to ensure tracking properly. Attachments (small tooth-colored bumps) placed if needed.'
        },
        {
          number: 5,
          title: 'Refinements (if needed)',
          description: 'If teeth don\'t track perfectly, additional aligners ordered. Dr. Patel\'s experience minimizes refinement needs.'
        },
        {
          number: 6,
          title: 'Retention',
          description: 'Once finished, retainers worn nightly to maintain results. Without retainers, teeth will shift back.'
        }
      ]
    },
    
    faqs: [
      {
        question: 'How long does Invisalign take?',
        answer: 'Most cases take 12-18 months. Simple crowding or spacing might finish in 6-9 months. Complex bite corrections can take 18-24 months. Dr. Patel provides a realistic timeline at your consultation based on your specific case.'
      },
      {
        question: 'How much does Invisalign cost?',
        answer: 'At Restore.Dental, Invisalign typically costs £3,500-£5,500 depending on complexity. Simple cases (Invisalign Lite) start at £2,800. Complex cases requiring longer treatment cost up to £6,000. We offer 0% interest-free finance over 12-24 months.'
      },
      {
        question: 'Is Invisalign painful?',
        answer: 'Not painful, but you\'ll feel pressure for 2-3 days after switching to each new aligner — this is normal and means teeth are moving. The pressure is far less than traditional braces tightening. Over-the-counter pain relief helps if needed.'
      },
      {
        question: 'Can I eat with Invisalign?',
        answer: 'You remove aligners to eat, so there are no food restrictions — unlike braces where sticky/hard foods are banned. Just brush teeth before reinserting aligners. This flexibility is a major advantage for most patients.'
      },
      {
        question: 'Will people notice I\'m wearing Invisalign?',
        answer: 'Invisalign is virtually invisible. Most people won\'t notice unless you tell them. Attachments (small tooth-colored bumps) are visible up close but blend with teeth. Far more discreet than metal braces.'
      },
      {
        question: 'What if I lose an aligner?',
        answer: 'Move back to the previous aligner and contact the practice immediately. We can often order replacements or advance you to the next aligner depending on timing. Keep your previous aligners as backups.'
      },
      {
        question: 'Do I have to wear aligners 22 hours a day?',
        answer: 'Yes. Compliance is critical — wearing aligners only at night won\'t work. You need 20-22 hours/day for predictable results. Skipping wear time extends treatment or causes failure. Dr. Patel uses compliance indicators to track your wear.'
      }
    ],
    
    aftercare: {
      title: 'After Invisalign: Keeping Your Smile Straight',
      instructions: [
        'Wear retainers every night for life (or teeth will shift back)',
        'Clean retainers daily with toothbrush and mild soap',
        'Bring retainers to dental check-ups for inspection',
        'Replace retainers every 1-2 years as they wear out',
        'If retainers feel tight, wear them more consistently',
        'Report any tooth movement or retainer damage immediately'
      ],
      note: 'Retention is the most important phase. Skipping retainer wear means teeth will shift back within months — undoing all your investment. Nighttime wear is non-negotiable.'
    },
    
    relatedServices: ['composite-veneers', 'teeth-whitening', 'digital-smile-design']
  }

,

  'teeth-whitening': {
    slug: 'teeth-whitening',
    questionH1: 'What\'s the Safest Way to Whiten Your Teeth?',
    metaTitle: 'Teeth Whitening Acton — Professional Whitening | Restore.Dental',
    metaDescription: 'Professional teeth whitening in Acton. Safe, effective results. Home & in-chair options. Dr. Kartik Patel. From £350. Book consultation today.',
    keywords: 'teeth whitening Acton, professional whitening West London, white teeth, stain removal, cosmetic whitening',
  
    tldr: "Professional teeth whitening uses dentist-prescribed bleaching gels (carbamide or hydrogen peroxide) to safely lighten tooth color by several shades. At Restore.Dental, we offer both home whitening (custom trays you wear overnight for 2 weeks) and in-chair whitening (faster results in a single 90-minute appointment). Whitening addresses yellowing from age, coffee/tea/red wine staining, and smoking discoloration — but it won't fix intrinsic stains from medications or fluorosis. Dr. Patel assesses whether whitening will achieve your goals before you invest. Results last 1-3 years with good maintenance. Professional whitening is far safer and more effective than drugstore strips, which can cause sensitivity and patchy results. It's the most conservative cosmetic treatment — no drilling, no permanent changes, just brighter teeth.",
  
    whoItsFor: [
    'Anyone with yellowed or stained teeth from age, food, or smoking',
    'People wanting a brighter smile for weddings, interviews, or photos',
    'Patients seeking a conservative option before considering veneers',
    'Anyone who\'ve tried drugstore whitening without success',
    'Patients wanting to brighten teeth before bonding/crowns (to match restorations)'
    ],
  
    treatmentApproach: {
    title: 'Whitening Treatment Options',
    steps: [
      {
        number: 1,
        title: 'Assessment & Expectations',
        description: 'Shade measurement, assessment of stain type. Honest discussion: will whitening achieve your goals, or do you need veneers?'
      },
      {
        number: 2,
        title: 'Home Whitening (2 weeks)',
        description: 'Custom trays made from impressions. Wear trays with bleaching gel overnight for 10-14 nights. Gradual, controlled whitening.'
      },
      {
        number: 3,
        title: 'OR In-Chair Whitening (90 mins)',
        description: 'Gums protected, high-concentration gel applied to teeth, activated with LED light. Significant whitening in one visit.'
      },
      {
        number: 4,
        title: 'Post-Whitening Sensitivity Care',
        description: 'Desensitizing gel provided if needed. Sensitivity typically resolves within 48 hours.'
      },
      {
        number: 5,
        title: 'Top-Up Maintenance',
        description: 'Keep your trays and gel for occasional top-ups (every 6-12 months) to maintain brightness.'
      }
    ]
  },
  
  faqs: [
    {
      question: 'How much does teeth whitening cost?',
      answer: 'At Restore.Dental, home whitening costs £350-£450 (including custom trays and gel). In-chair whitening costs £500-£650. Combined treatment (in-chair boost followed by home maintenance) costs £700-£850. Home whitening is more cost-effective; in-chair is faster.'
    },
    {
      question: 'How white will my teeth get?',
      answer: 'Most patients lighten 3-8 shades. Final results depend on starting shade and stain type. Yellow/brown stains whiten best; grey stains (from tetracycline) are harder to shift. Dr. Patel shows you realistic expectations using shade guides at consultation.'
    },
    {
      question: 'Is teeth whitening painful?',
      answer: 'The process itself is painless, but many patients experience temporary tooth sensitivity to hot/cold for 24-48 hours after treatment. This resolves quickly and is managed with desensitizing products. Sensitivity is more common with in-chair whitening.'
    },
    {
      question: 'How long does whitening last?',
      answer: 'Results last 1-3 years depending on diet and habits. Coffee, red wine, smoking, and aging gradually re-stain teeth. Keeping your custom trays allows easy top-ups every 6-12 months to maintain brightness.'
    },
    {
      question: 'Will whitening damage my teeth?',
      answer: 'No. Professional whitening is safe when done under dental supervision. Drugstore strips and charcoal toothpastes can damage enamel if misused. Dr. Patel ensures whitening gel concentration is appropriate for your teeth and monitors for adverse effects.'
    },
    {
      question: 'Can I whiten if I have crowns or veneers?',
      answer: 'Whitening only affects natural teeth — crowns, veneers, and fillings don\'t change color. If you whiten after getting restorations, you may end up with mismatched shades. Dr. Patel advises whitening first, then matching restorations to your new shade.'
    },
    {
      question: 'Why is professional whitening better than drugstore strips?',
      answer: 'Professional whitening uses custom trays that ensure even gel distribution and prevent gum irritation. Drugstore strips often cause patchy results, gum burns, and enamel damage from improper use. Professional treatment is safer, more effective, and supervised by a dentist.'
    }
  ],
  
  aftercare: {
    title: 'Maintaining Your Whitened Smile',
    instructions: [
      'Avoid staining foods/drinks for 48 hours after treatment (white diet)',
      'Brush with whitening toothpaste to slow re-staining',
      'Limit coffee, tea, red wine, and smoking',
      'Rinse or brush after consuming staining foods',
      'Use desensitizing toothpaste if sensitivity persists',
      'Top up every 6-12 months with your custom trays'
    ],
    note: 'Whitening isn\'t permanent — teeth gradually re-stain over time. Good oral hygiene and occasional top-ups maintain results far longer.'
  },
  
  relatedServices: ['porcelain-veneers', 'composite-veneers', 'digital-smile-design']
  },

  'emergency-dentist': {
    slug: 'emergency-dentist',
    questionH1: 'What Should You Do in a Dental Emergency?',
    metaTitle: 'Emergency Dentist Acton — Same-Day Appointments | Restore.Dental',
    metaDescription: 'Emergency dentist in Acton. Same-day appointments for toothache, broken teeth, trauma. Dr. Kartik Patel. Call 07787 814 064 for urgent care.',
    keywords: 'emergency dentist Acton, toothache relief, dental pain, broken tooth, knocked out tooth, same day dentist',
  
    tldr: "Dental emergencies — severe toothache, knocked-out teeth, broken crowns, abscesses — require immediate care to prevent infection, save teeth, and relieve pain. At Restore.Dental, Dr. Kartik Patel reserves same-day emergency slots for established and new patients in crisis. Whether it's 8am Monday or 6pm Friday, call first — we'll triage your emergency and get you seen urgently. Dr. Patel's philosophy: getting you out of pain is the priority; comprehensive treatment planning comes later once the crisis is resolved. We handle trauma, infections, broken restorations, and acute pain with empathy and efficiency. Don't suffer at home or spend hours in A&E — dental emergencies are best handled by dentists. Call 07787 814 064 immediately if you're in pain.",
  
    whoItsFor: [
    'Anyone with severe, throbbing toothache that\'s unbearable',
    'Patients with knocked-out or loosened teeth from trauma',
    'People with broken crowns, fillings, or dentures',
    'Anyone with facial swelling, fever, or signs of dental abscess',
    'Patients with uncontrollable bleeding after tooth extraction'
    ],
  
    treatmentApproach: {
    title: 'Emergency Care Protocol',
    steps: [
      {
        number: 1,
        title: 'Phone Triage',
        description: 'Call 07787 814 064. We assess urgency and book same-day slot or give home-care advice if you can wait.'
      },
      {
        number: 2,
        title: 'Emergency Exam',
        description: 'X-rays and clinical exam to diagnose the problem — infection, crack, decay, trauma, etc.'
      },
      {
        number: 3,
        title: 'Immediate Relief',
        description: 'Pain control via anesthetic, drainage of abscess, temporary filling/crown, or extraction if tooth unsalvageable.'
      },
      {
        number: 4,
        title: 'Prescription (if needed)',
        description: 'Antibiotics for infection, painkillers for severe pain, antimicrobial mouthwash.'
      },
      {
        number: 5,
        title: 'Follow-Up Plan',
        description: 'Once crisis resolved, schedule definitive treatment — root canal, crown, implant, etc.'
      }
    ]
  },
  
  faqs: [
    {
      question: 'What counts as a dental emergency?',
      answer: 'True emergencies: severe pain that prevents sleep/work, knocked-out tooth, uncontrolled bleeding, facial swelling/fever (signs of infection), broken jaw. Non-emergencies that can wait: dull toothache, minor chip, lost filling. When in doubt, call — we\'ll triage.'
    },
    {
      question: 'How quickly can you see me in an emergency?',
      answer: 'Same day for true emergencies. We reserve slots daily for urgent cases. Call before 9am for best chance of a morning slot; call before 3pm for evening slots. Weekends are trickier but we try to accommodate.'
    },
    {
      question: 'What should I do if a tooth gets knocked out?',
      answer: 'Find the tooth, hold it by the crown (not root), rinse gently if dirty, try to reinsert it in the socket. If that\'s not possible, store it in milk or saliva (not water). Get to a dentist within 30 minutes — the faster you\'re seen, the better the chance of saving the tooth.'
    },
    {
      question: 'Can you fix a broken crown or filling on the same day?',
      answer: 'Often yes. Temporary crowns or fillings can be placed same-day to protect the tooth and relieve discomfort. Permanent restorations require lab fabrication (1-2 weeks), but you won\'t leave with a gap or exposed tooth.'
    },
    {
      question: 'What if I need a tooth extracted urgently?',
      answer: 'Dr. Patel can extract teeth same-day if they\'re unsalvageable and causing pain/infection. He\'ll discuss tooth replacement options (implant, bridge, denture) once the emergency is resolved. Getting you out of pain is the immediate priority.'
    },
    {
      question: 'How much does emergency treatment cost?',
      answer: 'Emergency exam and X-rays: £80-£120. Temporary fillings/crowns: £100-£150. Extractions: £150-£300. Definitive treatment (root canal, crown, etc.) costs more and is quoted separately. Payment is required on the day for emergency care.'
    },
    {
      question: 'Should I go to A&E or call a dentist?',
      answer: 'For dental pain, broken teeth, or lost fillings, call a dentist — A&E can\'t fix dental problems and you\'ll wait hours. Go to A&E only if you have: severe facial swelling closing your airway, uncontrollable bleeding, broken jaw, or head trauma. Otherwise, call us first.'
    }
  ],
  
  aftercare: {
    title: 'Post-Emergency Care Instructions',
    instructions: [
      'Take prescribed antibiotics/painkillers as directed — don\'t skip doses',
      'Avoid the affected tooth when eating until definitive treatment',
      'Rinse with warm salt water 3x daily to keep area clean',
      'Apply ice packs (20 min on, 20 min off) for swelling',
      'Sleep with head elevated to reduce throbbing',
      'Call immediately if pain worsens, swelling spreads, or fever develops'
    ],
    note: 'Emergency treatment stabilizes the crisis but definitive treatment (root canal, crown, extraction+implant) is still needed. Don\'t delay follow-up — temporary fixes aren\'t permanent.'
  },
  
  relatedServices: ['dental-implants', 'full-mouth-reconstruction', 'tmj-dentistry']
  },

  'tmj-dentistry': {
    slug: 'tmj-dentistry',
    questionH1: 'Could Your Jaw Pain Be TMJ Disorder?',
    metaTitle: 'TMJ Treatment Acton — Jaw Pain, Headaches | Restore.Dental',
    metaDescription: 'TMJ disorder treatment in Acton. Jaw pain, headaches, clicking joints. Bite splints, muscle therapy. Dr. Kartik Patel. Book consultation.',
    keywords: 'TMJ treatment Acton, jaw pain, TMD therapy, bite splints, bruxism treatment, jaw clicking',
  
    tldr: "TMJ (temporomandibular joint) disorders cause jaw pain, clicking/popping sounds, headaches, and difficulty opening your mouth. They're often linked to teeth grinding (bruxism), bite misalignment, or muscle tension. At Restore.Dental, Dr. Patel takes a conservative, evidence-based approach to TMJ treatment: custom bite splints to protect teeth and relax muscles, bite adjustment if misalignment is contributing, and referral for physiotherapy or massage if muscle tension is severe. Surgery is rarely needed. Most TMJ cases improve significantly with splint therapy and habit modification. Dr. Patel's training in occlusion (bite analysis) means he can distinguish true TMJ issues from referred pain or dental problems masquerading as TMJ. Honest diagnosis prevents unnecessary treatment.",
  
    whoItsFor: [
    'Anyone with chronic jaw pain, especially on waking',
    'Patients who clench or grind teeth (often unconsciously)',
    'People with frequent headaches or earaches of unclear origin',
    'Anyone with jaw clicking, popping, or locking',
    'Patients who\'ve worn teeth down from grinding'
    ],
  
    treatmentApproach: {
    title: 'TMJ Treatment Protocol',
    steps: [
      {
        number: 1,
        title: 'Comprehensive TMJ Assessment',
        description: 'Joint palpation, muscle examination, bite analysis, range-of-motion testing. Rule out dental causes of pain (infection, cracked teeth).'
      },
      {
        number: 2,
        title: 'Custom Bite Splint',
        description: 'Hard acrylic splint worn at night to prevent grinding, decompress joint, and relax muscles. Most effective conservative treatment.'
      },
      {
        number: 3,
        title: 'Habit Modification',
        description: 'Education on jaw posture, stress management, avoiding gum chewing, and recognizing daytime clenching.'
      },
      {
        number: 4,
        title: 'Bite Adjustment (if needed)',
        description: 'Minor reshaping of teeth if high spots are forcing jaw into unnatural position. Only done when clearly indicated.'
      },
      {
        number: 5,
        title: 'Referral for Adjunct Therapy',
        description: 'Physiotherapy, massage, or osteopathy for severe muscle tension. Collaboration with TMD specialists if case is complex.'
      }
    ]
  },
  
  faqs: [
    {
      question: 'What causes TMJ disorder?',
      answer: 'TMJ issues arise from multiple factors: teeth grinding (bruxism), bite misalignment, jaw trauma, arthritis, muscle tension from stress, or habitual gum chewing. Often it\'s a combination. Dr. Patel identifies contributing factors in your specific case rather than guessing.'
    },
    {
      question: 'Will a bite splint cure my TMJ?',
      answer: 'Splints significantly improve symptoms in 70-80% of cases by protecting teeth, decompressing the joint, and relaxing muscles. "Cure" is tricky — TMJ is often chronic and requires ongoing management. Splints are the most effective conservative treatment available.'
    },
    {
      question: 'How much does TMJ treatment cost?',
      answer: 'Custom bite splints cost £350-£500 at Restore.Dental. Bite adjustments (if needed) cost £100-£200. Physiotherapy referrals are NHS or private depending on availability. Most patients see significant improvement with just a splint.'
    },
    {
      question: 'How long until I feel better?',
      answer: 'Many patients notice reduced pain within 2-3 weeks of consistent splint wear. Full improvement often takes 2-3 months as muscles and joints adapt. Some cases require longer — TMJ is not a quick fix.'
    },
    {
      question: 'Do I have to wear the splint forever?',
      answer: 'Many patients wear splints long-term (nightly) to prevent symptom recurrence, especially if grinding persists. Some can eventually wean off if underlying stress or habits improve. Dr. Patel guides you based on your progress.'
    },
    {
      question: 'Will I need surgery?',
      answer: 'Rarely. TMJ surgery is reserved for severe structural damage (displaced disc, arthritis) that hasn\'t responded to conservative care. Over 90% of TMJ cases improve without surgery. Dr. Patel exhausts conservative options before ever mentioning surgery.'
    },
    {
      question: 'Can you fix my TMJ and grind teeth at the same time?',
      answer: 'Often they\'re the same problem. Grinding causes TMJ pain; TMJ pain increases muscle tension which worsens grinding. A bite splint addresses both by protecting teeth and relaxing the jaw. Treating one typically helps the other.'
    }
  ],
  
  aftercare: {
    title: 'Living with TMJ Disorder',
    instructions: [
      'Wear bite splint every night without fail',
      'Practice jaw relaxation: lips together, teeth apart',
      'Avoid hard, chewy foods (bagels, steak, gum) during flare-ups',
      'Apply warm compresses to jaw muscles for 15 minutes before bed',
      'Manage stress — it directly worsens clenching',
      'Report any new symptoms or worsening pain immediately'
    ],
    note: 'TMJ is often chronic and stress-related. Splint therapy manages symptoms effectively, but relapses happen if you stop wearing the splint or stress increases. Long-term management is key.'
  },
  
  relatedServices: ['full-mouth-reconstruction', 'emergency-dentist']
  },

  'digital-smile-design': {
    slug: 'digital-smile-design',
    questionH1: 'Can You See Your New Smile Before Treatment?',
    metaTitle: 'Digital Smile Design Acton — Preview Your New Smile | Restore.Dental',
    metaDescription: 'Digital smile design in Acton. See your new smile before veneers, crowns, or bonding. Dr. Kartik Patel. Virtual mock-ups. Book consultation.',
    keywords: 'digital smile design Acton, smile makeover preview, cosmetic dentistry planning, virtual smile design',
  
    tldr: "Digital Smile Design (DSD) uses photographs, videos, and digital software to create a virtual mock-up of your new smile before any treatment begins. At Restore.Dental, Dr. Patel uses DSD for complex cosmetic cases — full-mouth reconstructions, veneer makeovers, or implant restorations — so you see exactly what the final result will look like. This eliminates guesswork and ensures you're aligned on aesthetics before irreversible treatment. DSD also helps with treatment planning: Dr. Patel can show you multiple options (veneers vs. bonding, 8 teeth vs. 10 teeth, different shades) and you choose based on visual previews, not imagination. The result: predictable, beautiful outcomes that match your expectations. DSD is included in complex cosmetic treatment at no extra charge.",
  
    whoItsFor: [
    'Anyone considering veneers or full smile makeovers',
    'Patients anxious about cosmetic outcomes (will it look natural?)',
    'People wanting to compare treatment options visually',
    'Anyone investing significant money and wanting certainty before committing',
    'Patients with specific aesthetic goals (celebrity smile, natural look, etc.)'
    ],
  
    treatmentApproach: {
    title: 'Digital Smile Design Process',
    steps: [
      {
        number: 1,
        title: 'Comprehensive Photography & Video',
        description: 'High-resolution photos of smile, face, and teeth from multiple angles. Video of speaking and smiling naturally.'
      },
      {
        number: 2,
        title: 'Digital Mock-Up Creation',
        description: 'Software digitally "re-designs" your smile based on facial proportions, lip dynamics, and aesthetic principles.'
      },
      {
        number: 3,
        title: 'Review & Refinement',
        description: 'You review mock-ups, request changes (more/less white, different shape, etc.). Iterate until perfect.'
      },
      {
        number: 4,
        title: 'Wax Try-In (optional)',
        description: 'Physical prototype made from mock-up, placed temporarily in your mouth so you see/feel the design before committing.'
      },
      {
        number: 5,
        title: 'Treatment Execution',
        description: 'Final veneers, crowns, or bonding fabricated to match approved design exactly. No surprises.'
      }
    ]
  },
  
  faqs: [
    {
      question: 'How much does Digital Smile Design cost?',
      answer: 'At Restore.Dental, DSD is included at no extra charge for patients undergoing complex cosmetic treatment (6+ veneers, full-mouth cases, etc.). For standalone smile design consultation without treatment, the fee is £200-£300.'
    },
    {
      question: 'How accurate is the digital mock-up?',
      answer: 'Very accurate for shape, size, and proportions. Shade/color is approximate due to screen calibration differences. The mock-up is a close preview, not a pixel-perfect guarantee — but it eliminates the vast majority of uncertainty.'
    },
    {
      question: 'Can I see multiple design options?',
      answer: 'Yes. Dr. Patel can create 2-3 different designs (conservative vs. dramatic, different tooth shapes, varying whiteness) so you compare and choose your preferred aesthetic.'
    },
    {
      question: 'Do I have to do treatment after seeing the design?',
      answer: 'No. DSD is a planning tool. If you see the mock-up and decide treatment isn\'t right for you, you\'re under no obligation. Better to discover that before teeth are prepped, not after.'
    },
    {
      question: 'How long does the DSD process take?',
      answer: 'Photography appointment: 30-45 minutes. Design creation: 1-2 weeks. Review appointment: 30-60 minutes. If wax try-in is needed, add another 1-2 weeks. Total timeline: 2-4 weeks before starting actual treatment.'
    },
    {
      question: 'Is DSD necessary for all cosmetic work?',
      answer: 'No. Simple cases (single crown, minor bonding) don\'t need DSD. It\'s most valuable for full smile makeovers, multiple veneers, or complex reconstructions where aesthetics are critical and investment is significant.'
    },
    {
      question: 'What if I don\'t like the design?',
      answer: 'We refine it. DSD is iterative — you provide feedback, Dr. Patel adjusts the design, and you review again. The goal is mutual agreement before any irreversible work begins.'
    }
  ],
  
  aftercare: {
    title: 'After DSD: Moving to Treatment',
    instructions: [
      'Review and approve final design before treatment appointment',
      'Communicate any last-minute concerns or changes',
      'Understand that mock-up is a close preview, not a guarantee',
      'Bring reference photos if you have specific aesthetic goals',
      'Trust the process — Dr. Patel won\'t proceed unless you\'re confident',
      'Remember: good communication during design prevents disappointment later'
    ],
    note: 'DSD removes guesswork from cosmetic dentistry. It ensures you and Dr. Patel are aligned on aesthetics before treatment, dramatically reducing the risk of disappointing outcomes.'
  },
  
  relatedServices: ['porcelain-veneers', 'composite-veneers', 'full-mouth-reconstruction']
  },

  // === NEW SERVICES ===

  'sedation': {
    slug: 'sedation',
    questionH1: 'Is Sedation Dentistry Right for You?',
    metaTitle: 'Sedation Dentistry Acton — Anxiety-Free Dental Care | Dr. Kartik Patel',
    metaDescription: 'Sedation dentistry in Acton for anxious patients. IV sedation, oral sedation, twilight sedation. Safe, comfortable dental treatment. Book consultation.',
    keywords: 'sedation dentistry Acton, dental anxiety, IV sedation, sleep dentistry, nervous patient dentist',
    
    tldr: "Sedation dentistry helps anxious or phobic patients receive dental care in a relaxed, stress-free state. At Restore.Dental, we offer multiple sedation options including oral sedation and IV sedation (twilight sleep). You remain responsive but deeply relaxed, with little to no memory of the procedure. Ideal for complex treatments, lengthy appointments, or patients with dental phobia. All sedation is administered by trained professionals with full monitoring and safety protocols. Wake up with your treatment complete and minimal anxiety.",
    
    whoItsFor: [
      'Patients with dental phobia or severe anxiety',
      'Anyone with a strong gag reflex that makes treatment difficult',
      'Patients needing lengthy or complex procedures',
      'Those with past traumatic dental experiences',
      'People who struggle to get numb with local anesthetic alone'
    ],
    
    treatmentApproach: {
      title: 'Our Sedation Process',
      steps: [
        { number: 1, title: 'Pre-Sedation Consultation', description: 'Medical history review, sedation options explained, fasting instructions provided.' },
        { number: 2, title: 'Sedation Administration', description: 'Oral sedation taken before appointment, or IV sedation administered by trained clinician.' },
        { number: 3, title: 'Monitored Treatment', description: 'Vital signs continuously monitored. You remain responsive but deeply relaxed.' },
        { number: 4, title: 'Recovery', description: 'Wake up gradually. Must have responsible adult escort you home.' },
        { number: 5, title: 'Follow-Up', description: 'Check-in call next day to ensure you are recovering well.' }
      ]
    },
    
    faqs: [
      { question: 'Will I be unconscious?', answer: 'No. With IV sedation you\'re in a twilight state — responsive but deeply relaxed. General anesthesia (complete unconsciousness) is different and requires hospital setting.' },
      { question: 'Is sedation safe?', answer: 'Yes. We follow strict protocols with continuous monitoring. Medical history is screened beforehand. Sedation dentistry has an excellent safety record when administered properly.' },
      { question: 'Can I drive after sedation?', answer: 'No. You must have a responsible adult drive you home and stay with you for 24 hours. Sedation effects linger even after you feel alert.' }
    ],
    
    aftercare: {
      title: 'After Sedation',
      instructions: [
        'Arrange for adult escort before appointment',
        'Fast as instructed (usually 6-8 hours before IV sedation)',
        'Don\'t drive, operate machinery, or make important decisions for 24 hours',
        'Rest at home after treatment',
        'Expect some grogginess or memory gaps — this is normal',
        'Follow post-treatment dental care instructions once fully alert'
      ],
      note: 'Sedation dentistry transforms dental care for anxious patients. Treatment that once felt impossible becomes manageable and stress-free.'
    },
    
    relatedServices: ['emergency-dentist', 'dental-implants', 'full-mouth-reconstruction'],
    hubLink: {
      to: '/iv-sedation-dentistry',
      label: 'IV sedation at Acton W3',
      blurb: 'Want the detail on IV sedation specifically — what it feels like, what it costs, the escort rule and how you get home?',
    }
  },

  'bridges': {
    slug: 'bridges',
    questionH1: 'Are Dental Bridges Right for Replacing Missing Teeth?',
    metaTitle: 'Dental Bridges Acton — Fixed Tooth Replacement | Dr. Kartik Patel',
    metaDescription: 'Dental bridges in Acton. Fixed, permanent tooth replacement. Traditional, cantilever, and Maryland bridges. Natural-looking results. Book consultation.',
    keywords: 'dental bridges Acton, tooth replacement, fixed bridge, missing teeth, Maryland bridge',
    
    tldr: "Dental bridges are a fixed, non-removable solution for replacing one or more missing teeth. A bridge uses adjacent teeth as anchors to support a prosthetic tooth (pontic) that fills the gap. Unlike dentures, bridges are cemented in place and function like natural teeth. At Restore.Dental, Dr. Kartik Patel creates custom bridges that match your natural teeth in color, shape, and function. Bridges restore your smile, prevent teeth from shifting, and distribute bite forces evenly. With proper care, a well-made bridge can last 10-15 years or longer.",
    
    whoItsFor: [
      'Adults missing 1-3 consecutive teeth',
      'Patients who want fixed (non-removable) tooth replacement',
      'Those with strong, healthy adjacent teeth to support the bridge',
      'People seeking an alternative to dental implants',
      'Anyone wanting to prevent remaining teeth from shifting'
    ],
    
    treatmentApproach: {
      title: 'Bridge Treatment Process',
      steps: [
        { number: 1, title: 'Consultation & Planning', description: 'Assess adjacent teeth health, discuss bridge type, take impressions and photos.' },
        { number: 2, title: 'Tooth Preparation', description: 'Adjacent teeth (abutments) are shaped to support the bridge. Done under local anesthetic.' },
        { number: 3, title: 'Temporary Bridge', description: 'Temporary bridge placed while permanent bridge is crafted in dental lab (2-3 weeks).' },
        { number: 4, title: 'Final Bridge Placement', description: 'Permanent bridge tried in for fit and color match, then cemented into place.' },
        { number: 5, title: 'Follow-Up', description: 'Check-in after 1-2 weeks to ensure bite feels comfortable and gums are healthy.' }
      ]
    },
    
    faqs: [
      { question: 'How long do bridges last?', answer: '10-15 years on average with good care. Some last 20+ years. Longevity depends on oral hygiene, bite forces, and material quality.' },
      { question: 'Do bridges feel like real teeth?', answer: 'Yes. Once adjusted properly, bridges function and feel natural. Initial adjustment period is 1-2 weeks.' },
      { question: 'Can I floss with a bridge?', answer: 'Yes, but requires special technique or floss threaders to clean under the pontic. Dr. Patel will demonstrate proper cleaning.' }
    ],
    
    aftercare: {
      title: 'Caring for Your Bridge',
      instructions: [
        'Brush twice daily, paying attention to bridge margins',
        'Floss under pontic daily using floss threader or water flosser',
        'Avoid hard, sticky foods that could dislodge bridge',
        'Regular dental checkups every 6 months',
        'Report any looseness, discomfort, or gum changes immediately',
        'Consider night guard if you grind teeth'
      ],
      note: 'Bridges are durable and low-maintenance. With proper care, they provide decades of reliable function and aesthetics.'
    },
    
    relatedServices: ['dental-implants', 'crowns', 'dentures']
  },

  'dentures': {
    slug: 'dentures',
    questionH1: 'Are Dentures the Right Solution for You?',
    metaTitle: 'Dentures Acton — Full & Partial Dentures | Dr. Kartik Patel',
    metaDescription: 'Custom dentures in Acton. Full dentures, partial dentures, implant-supported dentures. Natural-looking, comfortable fit. 0% finance. Book consultation.',
    keywords: 'dentures Acton, false teeth, full dentures, partial dentures, implant dentures, affordable tooth replacement',
    
    tldr: "Dentures are removable prosthetic teeth designed to replace multiple missing teeth or a full arch. Modern dentures look natural, fit comfortably, and restore function for eating and speaking. At Restore.Dental, we offer full dentures (for complete tooth loss), partial dentures (for some remaining teeth), and implant-supported dentures (for superior stability). Dr. Kartik Patel takes precise impressions to ensure optimal fit and aesthetics. Dentures are a cost-effective solution that can dramatically improve quality of life. With proper care, dentures last 5-10 years before needing replacement.",
    
    whoItsFor: [
      'Adults missing most or all teeth in upper or lower arch',
      'Patients seeking an affordable tooth replacement option',
      'Those not suitable for implants due to bone loss or health conditions',
      'Anyone tired of struggling to eat, speak, or smile with missing teeth',
      'Patients who prefer removable (non-fixed) appliances'
    ],
    
    treatmentApproach: {
      title: 'Denture Creation Process',
      steps: [
        { number: 1, title: 'Consultation & Assessment', description: 'Evaluate remaining teeth, gum health, and bone structure. Discuss denture type and expectations.' },
        { number: 2, title: 'Impressions & Measurements', description: 'Detailed impressions of gums and jaw. Measurements for bite alignment and tooth position.' },
        { number: 3, title: 'Try-In Appointment', description: 'Wax model of denture tried in to check fit, appearance, and bite before final fabrication.' },
        { number: 4, title: 'Final Denture Delivery', description: 'Finished denture placed. Adjustments made for comfort. Instructions on insertion, removal, and care.' },
        { number: 5, title: 'Follow-Up Adjustments', description: '2-3 adjustment appointments over first month to fine-tune fit as gums adapt.' }
      ]
    },
    
    faqs: [
      { question: 'Will dentures look natural?', answer: 'Yes. Modern dentures are highly realistic. Tooth shape, size, and color are customized to suit your face and smile.' },
      { question: 'Can I eat normally with dentures?', answer: 'You\'ll need an adjustment period (2-4 weeks). Start with soft foods, progress to harder foods. Denture adhesive can improve stability. Implant-supported dentures offer best chewing function.' },
      { question: 'How long do dentures last?', answer: '5-10 years on average. Gums and bone change over time, requiring denture reline or replacement.' }
    ],
    
    aftercare: {
      title: 'Denture Care',
      instructions: [
        'Remove and rinse dentures after eating',
        'Brush dentures daily with soft brush and non-abrasive cleaner',
        'Soak dentures overnight in denture solution',
        'Rinse mouth and gums before reinserting dentures',
        'Remove dentures at night to allow gums to rest',
        'Visit dentist annually for denture check and oral exam'
      ],
      note: 'Dentures are a proven, affordable solution. With proper care and adjustments, they provide years of confident smiling, eating, and speaking.'
    },
    
    relatedServices: ['dental-implants', 'bridges', 'all-on-4-implants']
  },

  'crowns': {
    slug: 'crowns',
    questionH1: 'Do You Need a Dental Crown?',
    metaTitle: 'Dental Crowns Acton — Same-Day CEREC Crowns | Dr. Kartik Patel',
    metaDescription: 'Dental crowns in Acton. Same-day CEREC crowns, porcelain crowns, zirconia crowns. Restore broken, cracked, or root-canal-treated teeth. Book consultation.',
    keywords: 'dental crowns Acton, CEREC same-day crown, porcelain crown, tooth cap, broken tooth repair',
    
    tldr: "Dental crowns are custom-fitted caps that cover and protect damaged, weakened, or heavily restored teeth. Crowns restore strength, function, and appearance — effectively giving the tooth a new outer shell. At Restore.Dental, Dr. Kartik Patel offers same-day CEREC crowns (completed in one visit) and traditional lab-made crowns (porcelain, zirconia). Crowns are recommended after root canals, large fillings, fractures, or for cosmetic enhancement. With proper care, crowns last 10-20 years. They look and feel like natural teeth, blending seamlessly with your smile.",
    
    whoItsFor: [
      'Patients with cracked, broken, or severely worn teeth',
      'Anyone who had a root canal (crown protects brittle tooth)',
      'Those with large fillings taking up 50%+ of tooth structure',
      'People wanting to improve appearance of discolored or misshapen teeth',
      'Patients needing to anchor a dental bridge'
    ],
    
    treatmentApproach: {
      title: 'Crown Treatment Process',
      steps: [
        { number: 1, title: 'Consultation & Diagnosis', description: 'Examine tooth, take X-rays, determine if crown is best solution. Discuss material options.' },
        { number: 2, title: 'Tooth Preparation', description: 'Tooth is shaped to accommodate crown. Done under local anesthetic. Old filling or decay removed.' },
        { number: 3, title: 'Impression or Digital Scan', description: 'Traditional impression or digital scan taken. For CEREC crowns, crown is designed and milled same day.' },
        { number: 4, title: 'Temporary Crown (if needed)', description: 'If lab-made crown, temporary crown protects tooth for 1-2 weeks while permanent crown is crafted.' },
        { number: 5, title: 'Permanent Crown Placement', description: 'Crown tried in for fit and color, adjusted if needed, then cemented permanently.' }
      ]
    },
    
    faqs: [
      { question: 'Do crowns hurt?', answer: 'No. Procedure is done under local anesthetic. Some sensitivity after is normal for a few days. Pain should be minimal.' },
      { question: 'How long do crowns last?', answer: '10-20 years on average. Zirconia crowns tend to last longer than porcelain. Longevity depends on bite forces, grinding habits, and oral hygiene.' },
      { question: 'What\'s the difference between CEREC and lab crowns?', answer: 'CEREC crowns are completed same-day using computer milling. Lab crowns take 2 weeks but offer more aesthetic customization for front teeth. Both are durable and high-quality.' }
    ],
    
    aftercare: {
      title: 'Caring for Your Crown',
      instructions: [
        'Brush and floss normally — crowns can\'t get cavities, but gum line can',
        'Avoid chewing ice, hard candy, or using teeth as tools',
        'Wear night guard if you grind teeth',
        'Regular dental checkups to monitor crown and surrounding gum health',
        'Report any looseness, sensitivity, or gum changes immediately',
        'Crowns can last decades with proper care'
      ],
      note: 'Crowns are one of the most predictable and long-lasting dental treatments. They save teeth that would otherwise need extraction.'
    },
    
    relatedServices: ['bridges', 'dental-implants', 'porcelain-veneers']
  },

  'splints': {
    slug: 'splints',
    questionH1: 'Do You Need a Dental Splint or Night Guard?',
    metaTitle: 'Dental Splints & Night Guards Acton — TMJ Relief | Dr. Kartik Patel',
    metaDescription: 'Custom dental splints and night guards in Acton. Protect teeth from grinding, relieve TMJ pain. Michigan splint, NTI splint. Book consultation.',
    keywords: 'dental splint Acton, night guard, teeth grinding, bruxism, TMJ splint, occlusal guard',
    
    tldr: "Dental splints (also called night guards or occlusal guards) are custom-fitted appliances worn over teeth to protect against grinding, clenching, and TMJ dysfunction. At Restore.Dental, Dr. Kartik Patel creates custom splints tailored to your bite and symptoms. Splints reduce tooth wear, relieve jaw pain, and improve sleep quality. Different splint types (Michigan splint, NTI splint, soft vs. hard guards) are chosen based on your specific needs. A well-fitted splint can prevent thousands of pounds in future dental damage while alleviating chronic pain and headaches.",
    
    whoItsFor: [
      'Patients who grind or clench teeth (bruxism), especially at night',
      'Anyone with TMJ pain, jaw clicking, or limited jaw opening',
      'Those experiencing frequent headaches or facial pain',
      'Patients with worn, chipped, or cracked teeth from grinding',
      'People undergoing orthodontics or cosmetic dentistry (splint protects investment)'
    ],
    
    treatmentApproach: {
      title: 'Splint Fitting Process',
      steps: [
        { number: 1, title: 'Assessment & Diagnosis', description: 'Evaluate bite, jaw movement, tooth wear, and TMJ symptoms. Determine splint type needed.' },
        { number: 2, title: 'Impressions or Digital Scan', description: 'Precise impressions or scans taken to create custom-fitted splint.' },
        { number: 3, title: 'Splint Fabrication', description: 'Splint crafted in dental lab (1-2 weeks). Hard acrylic for durability, or soft material if needed.' },
        { number: 4, title: 'Fitting & Adjustments', description: 'Splint tried in, adjusted for comfort and proper bite balance. Instructions on wear and care.' },
        { number: 5, title: 'Follow-Up', description: 'Check-in after 2-4 weeks. Further adjustments made if needed. Monitor symptom improvement.' }
      ]
    },
    
    faqs: [
      { question: 'Will I get used to wearing a splint?', answer: 'Yes. Most patients adapt within 1-2 weeks. Initial awkwardness or excess saliva is normal and temporary.' },
      { question: 'Can I wear my splint during the day?', answer: 'Depends on splint type and your needs. Night guards are typically worn only during sleep. Daytime clenching may require a different type of splint.' },
      { question: 'How long do splints last?', answer: '3-5 years on average for hard splints. Soft splints wear out faster (1-2 years). Severe grinders may need replacement sooner.' }
    ],
    
    aftercare: {
      title: 'Splint Care',
      instructions: [
        'Rinse splint with cool water after each use',
        'Brush splint gently with toothbrush and mild soap (not toothpaste)',
        'Store in ventilated case when not in use',
        'Bring splint to dental checkups for inspection and adjustments',
        'Replace if cracked, worn through, or no longer fits properly',
        'Never use hot water (causes warping)'
      ],
      note: 'Splints are a simple, non-invasive solution that protects your teeth and relieves pain. Consistent nightly wear is key to seeing benefits.'
    },
    
    relatedServices: ['tmj-dentistry', 'bruxism', 'crowns']
  },

  'botox': {
    slug: 'botox',
    questionH1: 'Botox for TMJ, Grinding, and Facial Aesthetics?',
    metaTitle: 'Botox Dentistry Acton — TMJ Pain Relief & Cosmetic | Dr. Kartik Patel',
    metaDescription: 'Botox for TMJ pain, teeth grinding, and facial aesthetics in Acton. Medically trained injector. Relieve jaw pain, reduce grinding, smooth wrinkles. Book consultation.',
    keywords: 'Botox dentistry Acton, TMJ Botox, bruxism treatment, cosmetic Botox, masseter Botox, gummy smile correction',
    
    tldr: "Botox (botulinum toxin) is used in dentistry to treat TMJ disorders, teeth grinding (bruxism), and facial aesthetics. At Restore.Dental, Dr. Kartik Patel is trained in therapeutic and cosmetic Botox injections. Botox relaxes overactive jaw muscles, reducing pain, grinding, and headaches. It's also used to correct gummy smiles and soften facial wrinkles. Effects last 3-4 months, with repeat treatments needed for sustained results. Botox is minimally invasive, with results visible within 1-2 weeks. Ideal for patients seeking non-surgical relief from chronic jaw pain or cosmetic enhancement.",
    
    whoItsFor: [
      'Patients with TMJ pain, jaw clenching, or muscle tension',
      'Those who grind teeth severely (adjunct to night guard)',
      'Anyone with chronic tension headaches or migraines',
      'Patients wanting to soften facial wrinkles (crow\'s feet, forehead lines)',
      'Those seeking gummy smile correction without surgery'
    ],
    
    treatmentApproach: {
      title: 'Botox Treatment Process',
      steps: [
        { number: 1, title: 'Consultation & Assessment', description: 'Evaluate symptoms, muscle tension, and aesthetic goals. Explain Botox mechanism and realistic outcomes.' },
        { number: 2, title: 'Treatment Planning', description: 'Determine injection sites (masseter for TMJ/grinding, frontalis for wrinkles, etc.) and dosage.' },
        { number: 3, title: 'Botox Injection', description: 'Quick injections (5-10 minutes). Minimal discomfort. No anesthetic needed.' },
        { number: 4, title: 'Post-Treatment Instructions', description: 'Avoid lying down or heavy exercise for 4 hours. No rubbing or massaging injection sites.' },
        { number: 5, title: 'Follow-Up', description: 'Effects visible in 1-2 weeks. Check-in at 2 weeks. Repeat treatments every 3-4 months for sustained results.' }
      ]
    },
    
    faqs: [
      { question: 'Is Botox safe?', answer: 'Yes. Botox has been used medically for decades with excellent safety profile when administered by trained professionals. Side effects are rare and minor (temporary bruising, mild headache).' },
      { question: 'Will Botox freeze my face?', answer: 'No, when dosed appropriately. Dr. Patel uses conservative amounts to relax muscles while preserving natural expression. "Frozen" look only happens with overdose.' },
      { question: 'How long does Botox last?', answer: '3-4 months on average. Some patients find effects last longer with repeated treatments (5-6 months). Requires ongoing maintenance.' }
    ],
    
    aftercare: {
      title: 'After Botox Treatment',
      instructions: [
        'Avoid lying down for 4 hours post-injection',
        'No strenuous exercise or heavy lifting for 24 hours',
        'Don\'t rub or massage injection sites',
        'Avoid alcohol for 24 hours',
        'Expect results in 1-2 weeks (be patient)',
        'Book repeat appointment in 3-4 months for sustained results'
      ],
      note: 'Botox offers relief from chronic jaw pain and grinding while providing aesthetic benefits. It\'s a minimally invasive, well-tolerated treatment with high patient satisfaction.'
    },
    
    relatedServices: ['tmj-dentistry', 'bruxism', 'splints']
  },

  'bruxism': {
    slug: 'bruxism',
    questionH1: 'How to Stop Grinding and Clenching Your Teeth?',
    metaTitle: 'Bruxism Treatment Acton — Stop Teeth Grinding | Dr. Kartik Patel',
    metaDescription: 'Bruxism (teeth grinding) treatment in Acton. Custom night guards, Botox, stress management. Protect teeth, relieve jaw pain. Book consultation.',
    keywords: 'bruxism treatment Acton, teeth grinding, jaw clenching, night guard, TMJ, tooth wear',
    
    tldr: "Bruxism (teeth grinding and clenching) is a common condition that damages teeth, causes jaw pain, and disrupts sleep. At Restore.Dental, Dr. Kartik Patel treats bruxism with a multi-modal approach: custom night guards to protect teeth, Botox to relax overactive muscles, stress management guidance, and bite adjustments if needed. Left untreated, bruxism leads to worn teeth, fractures, TMJ dysfunction, and chronic headaches. Early intervention prevents thousands of pounds in future dental repairs. Most patients see dramatic improvement with a properly fitted night guard and lifestyle modifications.",
    
    whoItsFor: [
      'Adults or children who grind teeth (often noticed by partner or parent)',
      'Anyone with unexplained tooth wear, chipping, or fractures',
      'Patients experiencing jaw pain, stiffness, or clicking',
      'Those with frequent morning headaches or facial pain',
      'People under high stress or with anxiety'
    ],
    
    treatmentApproach: {
      title: 'Bruxism Treatment Plan',
      steps: [
        { number: 1, title: 'Diagnosis & Assessment', description: 'Examine teeth for wear patterns, assess jaw muscles, evaluate TMJ. Identify triggers (stress, sleep disorders, medications).' },
        { number: 2, title: 'Custom Night Guard', description: 'First-line treatment. Hard acrylic splint worn during sleep to protect teeth and reduce muscle strain.' },
        { number: 3, title: 'Botox (if severe)', description: 'For severe grinders, Botox injections relax masseter muscles, reducing clenching force and pain.' },
        { number: 4, title: 'Lifestyle & Stress Management', description: 'Guidance on stress reduction, sleep hygiene, avoiding caffeine/alcohol before bed. Jaw relaxation exercises.' },
        { number: 5, title: 'Ongoing Monitoring', description: 'Regular checkups to monitor tooth wear, adjust night guard, and assess symptom improvement.' }
      ]
    },
    
    faqs: [
      { question: 'What causes bruxism?', answer: 'Multifactorial: stress, anxiety, sleep disorders (sleep apnea), misaligned bite, genetics, medications (SSRIs), and caffeine/alcohol use. Often no single cause.' },
      { question: 'Can bruxism be cured?', answer: 'Not always "cured," but effectively managed. Night guards prevent damage. Botox reduces severity. Addressing underlying stress/sleep issues can resolve it in some cases.' },
      { question: 'What happens if I don\'t treat bruxism?', answer: 'Progressive tooth wear, fractures, loss of tooth structure, TMJ dysfunction, chronic pain, expensive restorative work (crowns, veneers). Early treatment is far cheaper than repairing damage.' }
    ],
    
    aftercare: {
      title: 'Managing Bruxism Long-Term',
      instructions: [
        'Wear night guard every night consistently',
        'Practice stress-reduction techniques (meditation, exercise, therapy)',
        'Avoid chewing gum, biting nails, or clenching during the day',
        'Limit caffeine and alcohol, especially in evening',
        'Maintain regular dental checkups to monitor wear',
        'Consider sleep study if snoring or sleep apnea suspected'
      ],
      note: 'Bruxism is manageable with the right tools and habits. A night guard is simple insurance against years of accumulated damage and pain.'
    },
    
    relatedServices: ['splints', 'tmj-dentistry', 'botox']
  }
};

export const getServiceBySlug = (slug) => {
  return services[slug];
};

export const getAllServiceSlugs = () => {
  return Object.keys(services);
};
